import React from "react";
import "./about.css";

function About(){
  return(
    <div id="About">
      <div className="about-me">
        <div>
          <h1 className="about-h1" data-aos="fade-right" data-aos-duration="600" data-aos-delay="100">ABOUT <span>ME</span></h1>
        </div>
      </div>
      <div className="discover-skills">
          <div className="who-i-am" data-aos="fade-right" data-aos-duration="600" data-aos-delay="300">
            <div>
              <div>
                <h2 className="about-h2"><span>Discover</span> who I am!</h2>
              </div>
            </div>
            <div>
                <p className="desc-self">I'm a dedicated Frontend Web Developer skilled in HTML, CSS, JavaScript and React JS, passionate about creating captivating user experiences. By merging design and technology, I transform concepts into responsive, interactive websites. With an eye for detail and a commitment to accessibility, I craft interfaces that marry aesthetics with functionality. Check out some of my work in the Portfolio section.
                </p>
            </div>
          </div>

          <div className="skills" data-aos="fade-right" data-aos-duration="600" data-aos-delay="500">
              <div>
                <h2 className="about-h2">My <span>Skills</span></h2>
              </div>
              <div className="skill-item-set">
                  <div className="skill-items">HTML</div>
                  <div className="skill-items">CSS</div>
                  <div className="skill-items">JavaScript</div>
                  <div className="skill-items">ReactJS</div>
                  <div className="skill-items">Bootstrap</div>
                  <div className="skill-items">Git</div>
                  <div className="skill-items">Github</div>
                  <div className="skill-items">C++</div>
                  <div className="skill-items">Python</div>
                  <div className="skill-items">API</div>
                  <div className="skill-items">AOS</div>
                  <div className="skill-items">Animations</div>
                  <div className="skill-items">Docker</div>
                  <div className="skill-items">K8s</div>
              </div>
          </div>
        </div>
    </div>
  );
}

export default About;
